'use client';

import dynamic from 'next/dynamic';
//* Styles
import ServicesTemplateStyle from './style';

//* Components
const HeroSection = dynamic(() => import('../components/HeroSection'), {
	ssr: true,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const ServicesTemplate = ({ pageData, servicesData }) => {
	const { faqs, content } = pageData;

	return (
		<ServicesTemplateStyle className='services-template'>
			<HeroSection
				{...content}
				data={servicesData}
			/>

			<FAQSection items={faqs} />
		</ServicesTemplateStyle>
	);
};

export default ServicesTemplate;
